import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import { styled, keyframes } from "@mui/system";

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  backgroundColor: "rgba(0,0,0,.3)",
  "& .browser-back-confirm-dialog": {
    "& .paper": {
      minHeight: "auto"
    }
  },
  "& .paper": {
    width: "500px",
    minHeight: "281px",
    borderRadius: "8px",
    boxShadow: "10px 10px 18px 0 rgba(0, 0, 0, 0.2)",
    backgroundColor: "#ffffff",
    "@media (max-width: 420px)": {
      height: "320px",
      overflow: "hidden"
    },
    "@media (max-width: 372px)": {
      height: "370px"
    }
  },
  "& .noTitlePaper": {
    top: "35%",
    position: "fixed",
    width: "780px",
    borderRadius: "8px",
    boxShadow: "10px 10px 18px 0 rgba(0, 0, 0, 0.2)",
    backgroundColor: "#ffffff",
    padding: "10px 0",
    [theme.breakpoints.between("lg", "xl")]: {
      transform: "translateX(-50%)",
      right: "unset",
      left: "50%",
      width: "780px"
    },

    "@media (max-width: 1280px)": {
      width: "780px"
    },
    "@media (max-width: 1024px)": {
      top: 0,
      position: "relative",
      right: "0px",
      width: "auto"
    }
  },
  "& .divider": {
    height: "1px",
    backgroundColor: "#dcdcdc"
  },
  "& .tlAuthErrorDialog": {
    "& .MuiPaper-root": {
      width: "30rem"
    }
  },
  "& .confirmRemoveMOISignDialog": {
    "& .MuiDialogTitle-root": {
      textAlign: "center"
    }
  },
  "& .dulConsentPendingDialog": {
    "& .MuiDialogTitle-root": {
      fontSize: "0.9rem",
      lineHeight: "normal",
      [theme.breakpoints.up("sm")]: {
        fontSize: "1.5rem"
      }
    },
    "& .MuiDialogContent-root": {
      fontWeight: 400,
      fontSize: "0.8rem",
      lineHeight: "normal",
      [theme.breakpoints.up("sm")]: {
        fontSize: "1.2rem"
      }
    }
  }
}));

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  padding: "40px 40px 20px 40px",
  "& > h2": {
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: 1.33,
    letterSpacing: "normal",
    [theme.breakpoints.up("md")]: {
      fontSize: "1.75rem"
    }
  }
}));

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: "8px 40px",
  "& .partnerSummaryConfirmNote": {
    background: "#FFF6F4",
    gap: "0.5rem",
    padding: "0.75rem",
    margin: "1rem 0rem",
    alignItems: "self-start",
    "& .noteIcon": {
      marginTop: "0.25rem",
      "& svg": {
        width: "1rem",
        height: "1rem"
      }
    },
    "& .noteDesc": { fontSize: "0.875rem", fontWeight: 400, lineHeight: "1.5rem" }
  },
  "& .tlAuthErrorDialog": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: "1rem",
    gap: "1rem",
    "& svg": {
      width: "2.08331rem",
      height: "2.08331rem"
    },

    "& .infoHeaderText": {
      margin: 0,
      color: "var(--Color-Text-Primary-On-Light, #1F1F1F)",
      textAlign: "center",
      fontSize: "1rem",
      fontWeight: 500,
      lineHeight: "1.375rem" /* 137.5% */
    },
    "& .infoText": {
      margin: 0,
      color: "var(--text-secondary-on-light, #757575)",
      textAlign: "center",
      fontFamily: "var(--font-family-DM-Sans, 'Rakbank Sans')",
      fontSize: "0.875rem",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "normal"
    }
  }
}));

export const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  padding: "20px",
  justifyContent: "center",
  "@media (max-width: 372px)": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  "&.MuiDialogActions-spacing": {
    "& > * + *": {
      marginLeft: "20px"
    }
  },
  "&.tlAuthErrorDialogActions": {
    display: "flex",
    flexDirection: "column-reverse",
    gap: "1rem",
    alignItems: "center",
    "& .MuiButton-root": {
      width: "100%",
      padding: "1rem 2rem",
      height: "3rem",
      borderRadius: "62.4375rem"
    },
    "&.MuiDialogActions-spacing": {
      "& > * + *": {
        marginLeft: "0px"
      }
    }
  }
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  minWidth: "150px",
  height: "40px",
  borderRadius: "21px",
  textTransform: "none",
  fontSize: "16px",
  fontWeight: 500,
  letterSpacing: "normal",
  whiteSpace: "nowrap",
  "&.MuiButton-contained": {
    color: "#fff",
    backgroundColor: "#000"
  },
  "&.MuiButton-outlined": {
    color: "#3b3a3a",
    border: "1px solid #3b3a3a"
  },
  "&.marginTop12": {
    "@media (max-width: 372px)": {
      marginTop: "12px",
      marginLeft: 0
    }
  },
  "& .loader": {
    width: "24px",
    height: "24px",
    margin: "0 auto",
    animation: `${rotate} 2s linear infinite`
  },
  "@media (max-width: 372px)": {
    width: "100%",
    marginLeft: 0
  }
}));
